module.exports = __webpack_public_path__ + "img/zh.98a500e0.svg";